import pt from '@/locales/countries/pt.json';
import br from '@/locales/countries/br.json';
import en from '@/locales/countries/en.json';
import es from '@/locales/countries/es.json';
import ar from '@/locales/countries/ar.json';
import ru from '@/locales/countries/ru.json';
import fr from '@/locales/countries/fr.json';
import it from '@/locales/countries/it.json';
import de from '@/locales/countries/de.json';

export default function langsList(code, storeLanguage) {

    let lang = [];

    switch (storeLanguage) {
        case "pt":
            lang = pt;
            break;

        case "br":
            lang = br;
            break;

        default:
        case "en":
            lang = en;
            break;

        case "es":
            lang = es;
            break;

        case "ar":
            lang = ar;
            break;

        case "ru":
            lang = ru;
            break;

        case "fr":
            lang = fr;
            break;

        case "it":
            lang = it;
            break;

        case "de":
            lang = de;
            break;
    }

    return lang.filter((item) => item.code === code).map(item => item.value).join();
}